export default __webpack_public_path__ + "static/media/team-health-check.14498e84.pdf";